import { ArchivedCampaignsState } from "@/mk2/apps/forum/containers/ArchivedCampaigns/ArchivedCampaigns.reducers";
import { LoadingState } from "@/mk2/reducers/loadingState";

export const initialArchivedCampaignsState: ArchivedCampaignsState = {
    ids: [],
    loadingState: LoadingState.INIT,
    errorMessage: null,
};
